import React from 'react'
import Amount from "../components/amount";
import { Modal, ModalHeader } from 'reactstrap';

export default class CateringModalDish extends React.Component {

  renderPriceRow(variantName, price){
    return (
      <div className="row dish-popup-selection-row mt-2 mb-2" key={'k'+variantName}>
        <div className="col-6 my-auto">{variantName} <span className="muted">(140kr)</span></div>
        {/*<div className="col-6">{variantName}: {price}kr</div>*/}
        <div className="col-6">
          <Amount
            min={0}
            max={999}
            step={1}
            value={(variantName in this.props.amounts) ? this.props.amounts[variantName] : 0}
            onChange={newValue => this.props.onAmountSet(this.props.dish.props.title, variantName, newValue)} />
        </div>
      </div>
    );
  }

  render(){
    if (typeof Modal === 'undefined' || !this.props.dish) {
      return (
        <div></div>
      );
    }
    return (
      <Modal isOpen={this.props.open} toggle={this.props.onClickOut} className='rounded'>
        <ModalHeader toggle={this.props.onClickOut}>{this.props.dish.props.title}</ModalHeader>
        {this.props.dish && (
          <div className="modal-body">
            <p>{this.props.dish.props.description}</p>
            <div className="variants">
              {this.props.dish.props.prices.map(priceEntry => {
                let [variantName, price] = priceEntry.split(':');
                let hasVariantName = isNaN(parseInt(variantName));
                if (!hasVariantName) {
                  return this.renderPriceRow(this.props.dish.props.title, price);
                }
                if (variantName.indexOf('/')!==-1) {
                  return variantName.split('/').map(subVariantName => (
                    this.renderPriceRow(subVariantName, price)
                  ))
                } else {
                  return this.renderPriceRow(variantName, price)
                }
              })}
            </div>
          </div>
        )}
        {!this.props.dish && (
          <p>Maträtten hittades inte</p>
        )}
        <div className="modal-footer">
          <button className="btn btn-orange btn-block rounded" onClick={this.props.onCancel}>Stäng</button>
        </div>
      </Modal>
    );
  }

}
